<div class="center">
    <div class="d-flex justify-content-center" [class._input]="!readonly && !disabled" [class.cursor-pointer]="!readonly && !disabled" *ngIf="!focus">
        <span class="prefix" *ngIf="options?.prefix"><i class="fa fa-{{options?.prefix}}"></i></span>
        <!-- Traer configuracion de redondeo si es que se requiere -->
        <span>{{(value || 0) | number: value > 0 ? 2 : 1}}</span>
        <span class="suffix" *ngIf="options?.suffix">{{options?.suffix}}</span>
        </div>
    <input #input class="text-center" type="text" [value]="value" placeholder="00.00" *ngIf="focus" maxlength="15" (keypress)="isNumeric($event, input.value)" (blur)="setFocus(false)" (change)="emitValue(input.value); setFocus(false)">
</div>